import React, { Component, Fragment } from 'react';
import { MDBInput, MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBCardBody, MDBIcon, MDBRow, MDBCol } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Header from './ComponentFragments/Header';
import SelectSearch from 'react-select-search';

class TeamActivity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activityData: [],
            yearData: [],
            fromWeekData: [],
            toWeekData: [],
            selectedYear: "",
            selectedFromWeek: "",
            selectedToWeek: ""
        };
        this.formatter = new Formatter();
        this.onSubmit = this.onSubmit.bind(this);
        this.loadWeeksForYear = this.loadWeeksForYear.bind(this);
    }

    async loadWeeksForYear(year) {
        this.props.loaderOn();
        let fromWeekData = [];
        let toWeekData = [];

        var dl = new DataLayer();
        let result = await dl.Get('/common/getweeksforyear?yearId=' + year, 200);
        result.data.forEach((week) => fromWeekData.push({ value: week.value, name: week.label }));
        result.data.forEach((week) => toWeekData.push({ value: week.value, name: week.label }));

        this.setState({
            fromWeekData: fromWeekData,
            toWeekData: toWeekData,
            selectedYear: year,
            selectedFromWeek: fromWeekData[0].value,
            selectedToWeek: toWeekData[0].value
        });

        this.props.loaderOff();
    }

    async onSubmit(event) {
        this.props.loaderOn();
        event.preventDefault();
        var dl = new DataLayer();
        await dl.Get('/teamleader/getteamactivity?fromWeek=' + this.state.selectedFromWeek + '&toWeek=' + this.state.selectedToWeek + '&sales=' + event.target.sales.value, 200).then((response) => {
            this.setState({
                activityData: response.data
            });
            this.props.loaderOff();
        })

    }

    async componentWillMount() {
        this.props.loaderOn();
        let yearData = [];
        let fromWeekData = [];
        let toWeekData = [];


        var dl = new DataLayer();
        let result = await dl.Get('/common/getyears', 200);
        result.data[0].forEach((year) => yearData.push({ value: year.value, name: year.label }));
        result.data[1].forEach((week) => fromWeekData.push({ value: week.value, name: week.label }));
        result.data[1].forEach((week) => toWeekData.push({ value: week.value, name: week.label }));

        this.setState({
            yearData: yearData,
            fromWeekData: fromWeekData,
            toWeekData: toWeekData,
            selectedYear: yearData[0].value,
            selectedFromWeek: fromWeekData[0].value,
            selectedToWeek: toWeekData[0].value
        });

        this.props.loaderOff();
    }

    render() {
        return (
            <div>
                <Header headerText="Team Activity" hideSearch={true} />
                <form onSubmit={this.onSubmit}>

                    <MDBRow className="mt-3">
                        <MDBCol sm="12">
                            <SelectSearch
                                options={this.state.yearData}
                                placeholder="Year..."
                                value={this.state.selectedYear}
                                search={false}
                                onChange={(selectedItem) => this.loadWeeksForYear(selectedItem.value)}
                            />
                            <SelectSearch
                                options={this.state.fromWeekData}
                                placeholder="From Week..."
                                value={this.state.selectedFromWeek}
                                search={false}
                                onChange={(selectedItem) => {
                                    this.setState({
                                        selectedFromWeek: selectedItem.value
                                    });
                                }}
                            />
                            <SelectSearch
                                options={this.state.toWeekData}
                                placeholder="From Week..."
                                value={this.state.selectedToWeek}
                                search={false}
                                onChange={(selectedItem) => {
                                    this.setState({
                                        selectedToWeek: selectedItem.value
                                    });
                                }}
                            />
                            <MDBInput
                                label="Sales More Than"
                                name="sales"
                                type="number"
                                required
                            />
                        </MDBCol>
                        <MDBCol md="12" sm="12">
                            <MDBBtn type="submit" className="float-right">Find</MDBBtn>
                        </MDBCol>
                    </MDBRow>
                 </form>

                <MDBRow>
                    {
                        this.state.activityData.map((dem) => {
                            return (
                                <MDBCol xl="3" lg="3" md="4" sm="12" className="mb-r" >
                                    <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                        <MDBCardTitle style={{ fontSize: "16px" }}>&nbsp;<MDBIcon icon="users" />&nbsp;&nbsp;{dem.unitName}</MDBCardTitle>
                                        <MDBCardTitle style={{ fontSize: "16px" }}>&nbsp;<MDBIcon icon="id-card" />&nbsp;&nbsp;{dem.unitCode}</MDBCardTitle>
                                        <hr />
                                        <MDBCardText>
                                            <MDBIcon far icon="user" />&nbsp;{dem.name}<br />
                                            <MDBIcon far icon="id-card" />&nbsp;{dem.sfCurrentCode}<br />
                                            <MDBIcon icon="phone" />&nbsp;{dem.telephoneCell}
                                        </MDBCardText>
                                        <hr />
                                        <div className="flex-row text-center" >
                                            <span><MDBIcon icon="coins" />&nbsp;Sales:&nbsp;<strong>{this.formatter.formatCurrency(dem.sales)}</strong></span>
                                        </div>
                                    </MDBCard>
                                </MDBCol>
                            );
                        })
                    }
                </MDBRow>

            </div>

        )
    }
}

export default TeamActivity;


